import { PatientNote } from '../../api/patients.types';
import { UpdatePatientTagsRequest } from '../patient/types';

export type PatientNotesTypeAction =
  | FetchNotesAction
  | SetNotesFetchingAction
  | SetNotesAction
  | GenericPatientNoteAction<'PATIENT_NOTES_SET_NOTE'>
  | CreateNoteAction
  | GenericPatientNoteAction<'PATIENT_NOTES_DELETE_NOTE'>
  | GenericPatientNoteAction<'PATIENT_NOTES_UPDATE_NOTE'>;

export interface FetchNotesAction {
  type: 'PATIENT_NOTES_FETCH';
  data: {
    patientId: string;
  };
}

export function fetchNotes(patientId: string): FetchNotesAction {
  return {
    type: 'PATIENT_NOTES_FETCH',
    data: { patientId },
  };
}

export interface SetNotesFetchingAction {
  type: 'PATIENT_NOTES_SET_NOTES_FETCHING';
  data: {
    patientId: string;
    fetching: boolean;
  };
}
export function setNotesFetching(patientId: string, fetching: boolean): SetNotesFetchingAction {
  return {
    type: 'PATIENT_NOTES_SET_NOTES_FETCHING',
    data: {
      patientId,
      fetching,
    },
  };
}

export interface SetNotesAction {
  type: 'PATIENT_NOTES_SET_NOTES';
  data: {
    patientId: string;
    notes: PatientNote[];
  };
}

export function setNotes(patientId: string, notes: PatientNote[]): SetNotesAction {
  return {
    type: 'PATIENT_NOTES_SET_NOTES',
    data: {
      patientId,
      notes,
    },
  };
}

export interface GenericPatientNoteAction<T = any> {
  type: T;
  data: {
    patientNote: PatientNote;
  };
}

export function setNote(patientNote: PatientNote): GenericPatientNoteAction<'PATIENT_NOTES_SET_NOTE'> {
  return {
    type: 'PATIENT_NOTES_SET_NOTE',
    data: { patientNote },
  };
}

export interface CreateNoteAction {
  type: 'PATIENT_NOTES_CREATE_NOTE';
  data: {
    patientId: string;
    note: string;
    visitCode?: string;
    operationsOnly?: boolean;
  };
}

export interface UpdatePatientTagsAction {
  type: 'PATIENT_TAGS_UPDATE';
  data: {
    patientId: string;
    updateRequest: UpdatePatientTagsRequest;
  };
}

export function createNote(patientId: string, note: string, visitCode?: string, operationsOnly?: boolean): CreateNoteAction {
  return {
    type: 'PATIENT_NOTES_CREATE_NOTE',
    data: { patientId, note, visitCode, operationsOnly },
  };
}

export function updatePatientTags(patientId: string, updateRequest: UpdatePatientTagsRequest): UpdatePatientTagsAction {
  return {
    type: 'PATIENT_TAGS_UPDATE',
    data: { patientId, updateRequest },
  };
}

export function deleteNote(patientNote: PatientNote): GenericPatientNoteAction<'PATIENT_NOTES_DELETE_NOTE'> {
  return {
    type: 'PATIENT_NOTES_DELETE_NOTE',
    data: { patientNote },
  };
}

export function updateNote(patientNote: PatientNote): GenericPatientNoteAction<'PATIENT_NOTES_UPDATE_NOTE'> {
  return {
    type: 'PATIENT_NOTES_UPDATE_NOTE',
    data: { patientNote },
  };
}
